import { render } from "./PvCheckbox.vue?vue&type=template&id=1b2161c0"
import script from "./PvCheckbox.vue?vue&type=script&lang=js"
export * from "./PvCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__